<template>
    <div>
        <div class="card">
            <div class="card-header">
                项目批次信息
            </div>
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">财政年份</th>
                    <td class="text-left align-middle" style="width: 15%">{{ projectBatchInfo.fileYear }}</td>
                    <th class="text-center align-middle" style="width: 10%">实施年份</th>
                    <td class="text-left align-middle" style="width: 15%">{{ projectBatchInfo.implYear }}</td>
                    <th class="text-center align-middle" style="width: 10%">状态</th>
                    <td class="text-left align-middle" style="width: 40%">{{ projectBatchInfo.stateName }}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">批次备注</th>
                    <td class="text-left align-middle" colspan="5">{{ projectBatchInfo.memo }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                项目类型信息
            </div>
            <div class="card-body" v-if="projectBatchCategoryData.length===0">
                <div class="alert alert-warning mb-0">没有项目类别信息</div>
            </div>
            <table class="table table-bordered mb-0" v-else>
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 60%">类别名称</th>
                    <th class="text-center align-middle" style="width: 10%">培训层次</th>
                    <th class="text-center align-middle" style="width: 20%">培训时长</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(category, index) in projectBatchCategoryData" :key="category.batchCategoryId">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-left align-middle">{{category.categoryName}}</td>
                    <td class="text-center align-middle">{{category.collegeLevelName}}</td>
                    <td class="text-center align-middle">{{category.trainLength}}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                主管部门联系人信息
            </div>
            <div class="card-body" v-if="projectBatchContactData.length===0">
                <div class="alert alert-warning mb-0">没有联系人信息</div>
            </div>
            <table class="table table-bordered mb-0" v-else>
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">姓名</th>
                    <th class="text-center align-middle" style="width: 10%">性别</th>
                    <th class="text-center align-middle" style="width: 15%">电话号码</th>
                    <th class="text-center align-middle" style="width: 15%">手机号码</th>
                    <th class="text-center align-middle" style="width: 20%">电子邮箱</th>
                    <th class="text-center align-middle" style="width: 30%">备注</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="contact in projectBatchContactData" :key="contact.pkId">
                    <td class="text-center align-middle">{{contact.personName}}</td>
                    <td class="text-center align-middle">{{contact.genderName}}</td>
                    <td class="text-center align-middle">{{contact.phoneNumber}}</td>
                    <td class="text-center align-middle">{{contact.mobilePhone}}</td>
                    <td class="text-left align-middle">{{contact.emailAddress}}</td>
                    <td class="text-left align-middle">{{contact.memo}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";
export default {
    name: "ProjectBatchInfoView",
    props: {
        batchId: {type: String, required: true},
    },
    data: function () {
        return {
            projectBatchInfo: {},
            projectBatchCategoryData: [],
            projectBatchContactData: [],

        };
    },
    mounted() {
        this.getProjectBatchInfo();
        this.getProjectBatchCategoryData();
        this.getProjectBatchContactData();
    },
    methods: {
        getProjectBatchInfo() {
            projectApi.batch.getProjectBatchInfo(this.batchId).then(res => {
                this.projectBatchInfo = res.data;
            });
        },
        getProjectBatchCategoryData() {
            projectApi.batch.category.getProjectBatchCategoryData(this.batchId).then(res => {
                this.projectBatchCategoryData = res.data;
            });
        },
        getProjectBatchContactData() {
            projectApi.batch.contact.getProjectBatchContactData(this.batchId).then(res => {
                this.projectBatchContactData = res.data;
            });
        }
    }
}
</script>

<style scoped>

</style>